import React from 'react';

import { useParams } from 'react-router-dom';
import Additional from './Additional';
import Feedback from './Feedback';

function Question() {
  const { type } = useParams();

  if (type === 'additional') return <Additional />;

  return <Feedback />;
}

export default Question;
